<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      六和站<br>
站点介绍<br>
六和站位于深汕公路与东纵路交叉口东北侧地块内，车站呈南北向布置。车站采用站城一体化理念，实现无缝衔接。车站设置有5个出入口，其中B1口为主要紧急出入口,A2口为备用紧急出入口。田心方向公交接驳口在A3口、大运方向公交接驳口在A2口，A1出入口通道处设置公共卫生间（含第三卫生间）。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
大运	06:23	23:32	16号线	5分32秒	6分47秒<br>
田心	06:01	23:16	16号线	5分32秒	6分47秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
大运	06:32	23:32	16号线	5分50秒	6分钟-9分钟<br>
田心	06:06	23:16	16号线	5分50秒	6分钟-9分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
大运	06:32	00:32	16号线	5分50秒	6分钟-9分钟<br>
田心	06:06	00:16	16号线	5分50秒	6分钟-9分钟<br><br>

站点出口信息<br><br>
A1出入口:<br>
宝山第二工业区<br><br>
A2出入口:<br>
坪山区疾控中心<br><br>
A3:<br>
横岭塘科技围合小区<br><br>
B1出入口:<br>
坪山广场、六和城<br><br>
B2出入口:<br>
坪山六联幼儿园<br><br>
公交换乘信息<br><br>
A1出入口:<br>
公交站名： 山疾控中心公交站<br>
818、939、964、978、B811、E34、 E34路大站快线、M136、M195、M277、M279、M296、M325、M357、M361、M368、M434、M443、M480、M546<br><br>
B1出入口:<br>
公交站名： 六和城公交站<br>
818、939、941、963、B811、M195、M279、M357、M368、M447、M480<br><br>
B2 出入口:<br>
公交站名： 坪山围公交站<br>
941、939、941、963、B811、M195、M279、M357、M368、M447、M480、M564<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "shiliuhaoxian",
            title: "16号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>